import { MChatInput, UltimoMChatQuery } from 'graphql/types.generated'
import { isEmpty } from 'lodash'

import { convertConsultaSeguimentoToInput } from './consulta-seguimento/converter-consultaSeguimento'
import { convertMChatQueryToModel, convertMChatToPerguntaRespostaInput } from './mchat/converter-mchat'
import { MChatQueryModel } from './mchat/model-mchat'
import { MChatRfFieldModel, MChatRfViewModel } from './model-mChatRf'

export const convertMChatRfToInput = (value: MChatRfFieldModel): MChatInput => {
  if (isEmpty(value)) return null
  return {
    aplicacaoMChatR: convertMChatToPerguntaRespostaInput(value.mchat),
    aplicacaoMChatRf: convertConsultaSeguimentoToInput(value.consultaSeguimento),
  }
}

export const convertMChatRfQueryToModel = (mChat: Omit<MChatQueryModel, 'dataResultado'>): MChatRfFieldModel => {
  return {
    consultaSeguimento: null,
    mchat: convertMChatQueryToModel(mChat),
  }
}

export const convertMChatRfQueryToViewModel = (mChat: UltimoMChatQuery['ultimoMChatR']): MChatRfViewModel => {
  if (isEmpty(mChat)) return null

  return {
    consultaSeguimento: null,
    mchat: {
      ...convertMChatQueryToModel(mChat),
      dataResultado: mChat.dataResultado,
      lotacao: mChat.atendimentoProfissional.lotacao,
      atendimentoProfissionalId: mChat.atendimentoProfissional.id,
    },
  }
}
